import { createSelector } from 'reselect';

import { getSelectedInterventionId } from 'modules/interventions/selectors';
import { getByIds, getUIState } from 'modules/leads/selectors/core';
import { getDealerDefaultLanguage, getSelectedDealerId } from 'selectors/dealerSelectors';
import { getRoot } from 'utils/selectors';

const getState = createSelector(getUIState, ({ intervention }) => intervention);

const getInterventionIds = createSelector(getState, ({ ids }) => ids);

export const getInterventionLeads = createSelector(getRoot, getInterventionIds, getByIds);

export const getPage = createSelector(getState, ({ page }) => page);

export const isLoading = createSelector(getState, ({ loading }) => loading);

const getFilters = createSelector(getState, ({ filters }) => filters);

export const getSearchFilter = createSelector(getFilters, ({ text }) => text);

export const getParams = createSelector(
  getFilters,
  getPage,
  getSelectedDealerId,
  getDealerDefaultLanguage,
  getSelectedInterventionId,
  (filters, { number: page, size }, dealerId, language, interventionId) => ({
    ...filters,
    dealerId,
    page,
    size,
    language,
    interventionId,
  })
);
